module.exports = __webpack_public_path__ + "components/flag/static/square/ki-574a640982778da367e925c81044d0ed.svg";